import { ApplicationConfig, provideZoneChangeDetection, importProvidersFrom, APP_INITIALIZER, ErrorHandler } from '@angular/core';
import { provideRouter } from '@angular/router';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { provideNgxMask } from 'ngx-mask';
import AuraCustom from './config/aura-custom-theme';

import { routes } from './app.routes';
import { authInterceptor } from './interceptors/auth.interceptor';
import { LanguageService } from './core/services/language.service';
import { createTranslateFallbackLoader } from './core/loaders/translate-fallback.loader';
import { GlobalErrorHandler } from './core/handlers/global-error.handler';

export function httpTranslateLoader(http: HttpClient) {
  return createTranslateFallbackLoader(http);
}

export function initLanguage(lang: LanguageService): () => Promise<void> {
  return () => lang.initAsync();
}

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: AuraCustom,
      },
    }),
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'pt',
        loader: {
          provide: TranslateLoader,
          useFactory: httpTranslateLoader,
          deps: [HttpClient],
        },
      })
    ),
    provideNgxMask(),
    { provide: APP_INITIALIZER, useFactory: initLanguage, deps: [LanguageService], multi: true },
  ],
};
